module.exports = __webpack_public_path__ + "static/media/four-business.594b0015.svg";